<template>
  <div class="form-group">
    <label :for="name" class="d-none">{{ name }}</label>
    
    <textarea
      v-if="type === 'textarea'"
      v-mask="mask"
      :placeholder="placeholder"
      :value="value"
      :name="name"
      :rows="rows"
      :required="required"
      :readonly="readonly"
      :disabled="disabled"
      :maxlength="maxlength"
      @input="inputChanged"
      v-on="listeners"
      @blur="touchValidation"
      :class="classValidation()"
      ref="input"
    ></textarea>

    <input
      v-if="type !== 'textarea'"
      :type="type"
      v-mask="mask"
      placeholder=" "
      :value="value"
      :name="name"
      :autocomplete="autocomplete"
      :required="required"
      :readonly="readonly"
      :disabled="disabled"
      :maxlength="maxlength"
      @input="inputChanged"
      v-on="listeners"
      @blur="touchValidation"
      :class="classValidation()"
      ref="input"
    />
    <label
      v-if="placeholder && type !== 'textarea'"
    >{{ placeholder }}</label>
  </div>
</template>

<script>
  import { VueMaskDirective as mask } from 'v-mask'
  import classValidationChecker from '@/utils/classValidationChecker'

  export default {
    props: {
      ucwords: { type: Boolean, default: false },
      value: { type: String, default: '' },
      rows: { type: String, default: '3' },
      mask: { type: String, default: '' },
      placeholder: { type: String, default: '' },
      autocomplete: { type: String, default: 'on' },
      name: { type: String, default: null },
      readonly: { type: Boolean, default: false },
      required: { type: Boolean, default: false },
      disabled: { type: Boolean, default: false },
      focus: { type: Boolean, default: false },
      maxlength: { type: String, default: '' },
      validation: { type: Object, default: null },
      type: { type: String, default: 'text' }
    },

    directives: { mask },

    computed: {
      listeners() {
        // eslint-disable-next-line no-unused-vars
        const { input, ...listeners } = this.$listeners;
        return listeners;
      }
    },

    mounted () {
      if (this.focus) {
        this.$nextTick(() => this.$refs.input.focus())
      }

      if (this.ucwords) {
        this.$nextTick(() => {
          const newValue = this.value.replace(/^(.)|\s+(.)/g, ($1) => {
            return $1.toUpperCase()
          })
          this.$emit('input', newValue)
        })
      }
    },

    methods: {
      touchValidation () {
        if (this.validation) {
          this.validation.$touch()
        }
      },

      classValidation () {
        if (this.validation) {
          return classValidationChecker(this.validation)
        }
      },

      inputChanged (e) {
        let newValue = e.target.value

        if (this.ucwords) {
          newValue = newValue.replace(/^(.)|\s+(.)/g, ($1) => {
            return $1.toUpperCase()
          })
        }

        this.$emit('input', newValue)

        if (this.type == 'textarea') {
          e.target.style.minHeight = 'auto'
          e.target.style.minHeight = (e.target.scrollHeight) + 'px'
        }
      }
    }
  }
</script>